import { getMenuList } from 'api/user';
const state = {
  menuList: [], //侧边菜单列表
  tagsList: [], //打开的标签页个数,
  breadList: ['Dashboard'], //面包屑导航
  isCollapse: false, //侧边导航是否折叠
  theme: 'default',
  locale: localStorage.getItem('app_language') || 'en',
};
const getters = {
  browserHeaderTitle: (state) => state.browserHeaderTitle,
  getTheme: (state) => state.theme,
};
const mutations = {
  SET_LOCALE(state, lang) {
    state.locale = lang;
    localStorage.setItem('app_language', lang);
  },
  SET_MENU_LIST: (state, menuList) => {
    state.menuList = menuList;
  },
  //保存标签
  TAGES_LIST(state, arr) {
    state.tagsList = arr;
  },
  SET_BREAD_LIST(state, breadList) {
    state.breadList = breadList;
  },
  IS_COLLAPSE(state, bool) {
    state.isCollapse = bool;
  },
  SET_BROWSERHEADERTITLE: (state, action) => {
    state.browserHeaderTitle = action.browserHeaderTitle;
  },
  SET_THEME: (state, theme) => {
    state.theme = theme;
  },
};
const actions = {
  setLanguage({ commit }, lang) {
    commit('SET_LOCALE', lang);
  },
  getMenuList({ commit }, flag) {
    return new Promise((resolve, reject) => {
      getMenuList()
        .then((res) => {
          const { result, code } = res;
          if (code === 200) {
            commit('SET_MENU_LIST', result);
            if (flag) {
              commit('SET_BREAD_LIST', [result[0].title]);
            }
            resolve(result);
          } else {
            reject();
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setTheme({ commit }) {
    const url = window?.location.href ?? '';
    if (url.includes('gourdmobi')) {
      commit('SET_THEME', 'gourdmobi');
    } else if (url.includes('bananamobiads')) {
      commit('SET_THEME', 'bananamobiads');
    } else {
      commit('SET_THEME', 'default');
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
